import { PrivacyPolicyPage } from "../../component";

const PrivacyPolicy = () => {
  return <PrivacyPolicyPage />;
}
export default PrivacyPolicy;
